<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt50 pb50 relative">
            <div class="pages">
                <print ref="print"  :use-manifest="false">
                    <div class="header flex aic jcc" style="height:130px;position:relative;">
                        <div style="text-align: center">
                            <p style="font-size:22px;margin:0px">{{detailObj.consultGroup.initHosName}}</p>
                            <p style="font-size:14px;margin:0px">{{detailObj.consultGroup.initDeptName}}会诊咨询申请表</p>
                        </div>
                        <span style="position:absolute;left:25px;bottom:0;font-size: 14px;">NO.{{detailObj.consultGroup.consultGroupNo}}</span>
                    </div>
                    <div class="body" style="position: relative">
                        <div class="row bbb relative flex" style="height:210px;">
                            <div class="bbr" style="width: 15%;height:100%;">
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">申请医院</div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">患者姓名</div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">性别</div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">年龄</div>
                                <div class="flex aic jcc" style="height:20%;width:100%;">职业</div>
                            </div>
                            <div class="bbr" style="width: 50%;height:100%;">
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">{{detailObj.consultGroup.initHosName}}</div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.consulterName}}</div>
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">申请科室</div>
                                    <div class="flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.initDeptName}}</div>
                                </div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.consulterIdcard | getSexFromIdCardFilter}}</div>
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">申请医生</div>
                                    <div class="flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.initDocName}}</div>
                                </div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.consulterIdcard | getAgeFromIdCardFilter('岁')}}</div>
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">联系电话</div>
                                    <div class="flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.consulterMobile}}</div>
                                </div>
                                <div class="flex aic jcc" style="height:20%;width:100%;">
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.consulterJob}}</div>
                                    <div class="bbr flex aic jcc" style="height:100%;width:33%;">申请日期</div>
                                    <div class="flex aic jcc" style="height:100%;width:33%;">{{detailObj.consultGroup.hopeTime}}</div>
                                </div>
                            </div>
                            <div class="bbr flex aic jcc" style="width: 15%;height:100%;">申请类型</div>
                            <div style="width: 20%;height:100%;">
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <input type="checkbox" checked disabled
                                           v-if="detailObj.consultGroup.consultGroupType==='名医会诊'">
                                    <input type="checkbox" disabled v-else>名医会诊咨询
                                </div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <input type="checkbox" checked disabled
                                           v-if="detailObj.consultGroup.consultGroupType==='急会诊'">
                                    <input type="checkbox" disabled v-else>急会诊咨询
                                </div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <input type="checkbox" checked disabled
                                           v-if="detailObj.consultGroup.consultGroupType==='多科会诊'">
                                    <input type="checkbox" disabled v-else>多科会诊咨询
                                </div>
                                <div class="bbb flex aic jcc" style="height:20%;width:100%;">
                                    <input type="checkbox" checked disabled
                                           v-if="detailObj.consultGroup.consultGroupType==='ICU会诊'">
                                    <input type="checkbox" disabled v-else>ICU会诊咨询
                                </div>
                                <div class="flex aic jcc" style="height:20%;width:100%;">
                                    <input type="checkbox" checked disabled
                                           v-if="detailObj.consultGroup.consultGroupType==='护理会诊'">
                                    <input type="checkbox" disabled v-else>护理会诊咨询
                                </div>
                            </div>
                        </div>
                        <div class="row bbb relative flex" style="min-height: 160px;">
                            <div class="row bbr flex aic jcc" style="width: 15%;">
                                <div>
                                    <span class="flex aic jcc">简要病史</span>
                                    <span class="flex aic jcc">(申请医生填写)</span>
                                </div>
                            </div>
                            <div class="row flex aic pl20" style="width: 82%;">
                                <div>
                                    <span style="display: block;">主诉：{{detailObj.consultGroup.consultContent}}</span>
                                    <span style="display: block;">初步诊断：{{detailObj.consultGroup.beforeDiagnose}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row bbb relative flex" style="min-height: 160px;">
                            <div class="row bbr flex aic jcc" style="width: 15%;">
                                <div>
                                    <span class="flex aic jcc">申请会诊</span>
                                    <span class="flex aic jcc">目的(或事由)</span>
                                </div>
                            </div>
                            <div class="row flex aic pl20" style="width: 82%;">
                                {{detailObj.consultGroup.consultReason}}
                            </div>
                        </div>
                        <div class="row bbb relative flex" style="min-height: 140px;">
                            <div class="row bbr flex aic jcc" style="width: 15%;">会诊咨询意见</div>
                            <div class="row flex aic pl20" style="width: 82%;">
                                {{detailObj.consultGroup.consultAdvice}}
                            </div>
                        </div>
                        <div class="row relative flex" style="height: 80px;">
                            <div class="row bbr flex aic jcc" style="width:15%;height:100%;">会诊咨询科别</div>
                            <div class="row bbr flex aic jcc" style="width:20%;height:100%;">{{detailObj.consultGroup.acceptDeptName}}</div>
                            <div class="row bbr flex aic jcc" style="width:15%;height:100%;">专家签名</div>
                            <div class="row bbr flex aic jcc" style="width:20%;height:100%;"></div>
                            <div class="row bbr flex aic jcc" style="width:15%;height:100%;">职称</div>
                            <div class="row flex aic jcc" style="width:15%;height:100%;">{{detailObj.consultGroup.acceptDocTitle}}</div>
                        </div>
                        <div style="position: absolute;bottom:-20px;font-size:12px;">注：会诊中心咨询预约电话：0571-87767099,13486353771</div>
                    </div>
                    <!--<div class="body">-->
                        <!--<div class="row bbb relative flex" style="height: 70px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">转诊类型</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">门诊转诊</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">申请日期</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="height: 70px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">预约科室</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">预约专家</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="height: 70px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">预约转诊</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">申请医院</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="height: 70px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">申请科室</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">联系电话</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="min-height: 80px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">初步诊断</div>-->
                            <!--<div class="row flex aic pl20" style="width: 82%;min-height: 80px;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="min-height: 80px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">病情描述</div>-->
                            <!--<div class="row flex aic pl20" style="width: 82%;min-height: 80px;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="height: 70px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">患者姓名</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">患者性别</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="height: 70px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">身份证号</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">患者年龄</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231}</div>-->
                        <!--</div>-->
                        <!--<div class="row bbb relative flex" style="height: 80px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">电话</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;height: 100%;">23123</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;height: 100%;">联系地址</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;height: 100%;">231231</div>-->
                        <!--</div>-->
                        <!--<div class="row relative flex" style="min-height: 80px;">-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">安排转诊时间</div>-->
                            <!--<div class="row bbr flex aic pl20" style="width: 32%;min-height: 80px;">231231</div>-->
                            <!--<div class="row bbr flex aic jcc" style="width: 18%;min-height: 80px;">医生备注</div>-->
                            <!--<div class="row flex aic pl20" style="width: 32%;min-height: 80px;">231231</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <div class="btnGroup print-hidden">
                        <hos_button content="关闭" @clickEvent="close"></hos_button>
                        <hos_button type="affirm" content="打印" class="ml50" @clickEvent="print"></hos_button>
                    </div>
                </print>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from "../../components/common/Breadcrumb";
    import hos_button from "../../components/hos/hos-button"
    import {consultationService} from "../../lib/service/consultation"
    import {getSexFromIdCardFilter, getAgeFromIdCardFilter} from "../../lib/filters"
    export default {
        name: "report",
        components:{
            Breadcrumb,hos_button
        },
        data(){
            return{
                pages:['远程会诊','会诊单'],
                detailObj:{},
            }
        },
        filters: {getSexFromIdCardFilter, getAgeFromIdCardFilter},
        methods:{
            close(){
                this.$router.back();
            },
            //打印
            print(){
                this.$refs.print.print();
            },
            //查询统计表格数据
            async queryById(){
                this.detailObj = await consultationService.detail(this.$route.params.id)
            }
        },
        async created(){
            await this.queryById();
           // this.pageType = this.$route.params.type;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
    //A纸大小
    .pages{
        background: white;
        width: 21cm;
        display: block;
        margin: 0 auto;
        margin-bottom: 0.5cm;
        box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
        padding-bottom: 50px;
        position: relative;
        div{
            border-sizing:border-box;
        }
    }
    .header{
        width: 100%;
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #333333;
        letter-spacing: 0;
    }
    .body{
        width: calc(100% - 50px);
        position: relative;
        margin:0 25px 50px 25px;
        border: 1px solid #000000;
    }

    .row{
        width: 100%;
    }
    .btnGroup{
        position: absolute;
        right: 20px;
        bottom:-50px;
    }
</style>